import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79e84338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "holder" }

import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'bg-image',
  props: {
  img: String
},
  setup(__props) {

_useCssVars(_ctx => ({
  "3c2b05e7": (bgimage.value)
}))

const props = __props
const bgimage = computed(() => `url(${props.img})`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})